import React from "react";
import { useTranslation } from "react-i18next";

export const Features = () => {
  const { t } = useTranslation("landing");

  return (
    <header id="header">
      <div className="intro2">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-md-offset-2 col-xs-12 intro2-text">
                <h1>
                  {t("features.title")}
                  <span></span>
                </h1>
                <p></p>{" "}
              </div>
              <div className="col-md-6 col-xs-12 col-md-offset-2"></div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
